'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.99 21.991c5.695 0 10.396-4.7 10.396-10.386 0-5.685-4.71-10.386-10.406-10.386-5.685 0-10.376 4.7-10.376 10.386 0 5.685 4.7 10.386 10.386 10.386Zm0-2.07a8.278 8.278 0 0 1-8.297-8.316 8.267 8.267 0 0 1 8.287-8.307 8.301 8.301 0 0 1 8.327 8.307 8.289 8.289 0 0 1-8.317 8.317Zm-.221-6.317c.552 0 .904-.322.934-.733 0-.03 0-.08.01-.121.03-.512.382-.854 1.035-1.286.994-.643 1.627-1.225 1.627-2.38 0-1.668-1.507-2.632-3.295-2.632-1.717 0-2.893.783-3.204 1.728-.06.17-.1.341-.1.522 0 .492.381.794.843.794.593 0 .724-.302 1.035-.643.321-.503.743-.794 1.336-.794.793 0 1.316.452 1.316 1.125 0 .613-.422.944-1.276 1.527-.713.502-1.235 1.014-1.235 1.918v.111c0 .572.351.864.974.864Zm-.02 3.084c.643 0 1.175-.463 1.175-1.105 0-.633-.522-1.105-1.175-1.105s-1.185.472-1.185 1.105c0 .632.532 1.104 1.185 1.104Z",
    fill: "#1C1C1E"
  })));
};

exports.SvgHelp = SvgHelp;
